import type { Sprites } from '../types';

export const SPRITES: Sprites = {
  // Player characters
  paladin: [
    "   1111   ",
    "  111111  ",
    "  11dd11  ",
    "  111111  ",
    " 11111111 ",
    " 111b1b11 ",
    " 111b1b11 ",
    "    33    ",
    "   3  3   ",
    "   3333   "
  ],
  rogue: [
    "   rrrr   ",
    "  rrrrrr  ",
    "  r11rr1  ",
    "  rrrrrr  ",
    " 22222222 ",
    " r2r222r2 ",
    " r2r222r2 ",
    "  22  22  ",
    " 22    22 ",
    " 22    22 "
  ],
  knight: [
    "   bbbb   ",
    "  bbbbbbb ",
    "  bbbbbbb ",
    "  b11bb11 ",
    "  bbbbbbb ",
    " 11111111 ",
    " b1b11b1b ",
    "   1  1   ",
    "  11  11  ",
    "  11  11  "
  ],
  berserker: [
    "   wwww   ",
    "  wwwwww  ",
    "  wwww11  ",
    "  wwwwww  ",
    " wwwwwwww ",
    " ww11ww11 ",
    " ww11ww11 ",
    "   2  2   ",
    "  ww  ww  ",
    "  ww  ww  "
  ],
  wizard: [
    "          ",
    "   3333   ",
    "  333333  ",
    " 33r3r33  ",
    " 33333333 ",
    " 3r3333r3 ",
    "  333333  ",
    "   33 3   ",
    "  3   3   ",
    "     33   "
  ],
  pyromancer: [
    "   pppp   ",
    "  pppppp  ",
    "  p11pp1  ",
    "  pppppp  ",
    "  11111111",
    "  1r1r1r1r",
    "  1r1r1r1r",
    "   1  1   ",
    "  11  11  ",
    "  11  11  "
  ],
  ranger: [
    "   gggg   ",
    "  gggggg  ",
    "  g11gg1  ",
    "  gggggg  ",
    "  11111111",
    "  b1b1b1b1",
    "  b1b1b1b1",
    "   b  b   ",
    "  bb  bb  ",
    "  bb  bb  "
  ],
  // Enemies - these match the EntityType values
  basic: [
    "   wwwww  ",
    "  wggwwgg ",
    "  wwwwwww ",
    "   wwwww  ",
    "    111   ",
    "  1111111 ",
    "  1 111 1 ",
    "    1 1   ",
    "   1   1  ",
    "   1   1  "
  ],
  bat: [
    "  d   d   ",
    " d www d  ",
    "drwwwwwd  ",
    " dddrddd  ",
    "  ddddd   ",
    "   ddd    ",
    "    d     ",
    "          ",
    "          ",
    "          "
  ],
  elite: [
    "  111111  ",
    " 11r11r11 ",
    " 11111111 ",
    " 11111111 ",
    " 11111111 ",
    " 33333333 ",
    " 33333333 ",
    "  33  33  ",
    "  33  33  ",
    "  33  33  "
  ],
  boss: [
    "   wwwww  ",
    "  wrwwrw  ",
    "  wwwwww  ",
    "  wwwwww  ",
    " wwwwwwww ",
    " ww11ww11 ",
    " ww11ww11 ",
    "   2  2   ",
    "  22  22  ",
    "  22  22  "
  ],
  // Legacy names (kept for compatibility)
  shopper: [
    "   wwwww  ",
    "  wggwwgg ",
    "  wwwwwww ",
    "   wwwww  ",
    "    111   ",
    "  1111111 ",
    "  1 111 1 ",
    "    1 1   ",
    "   1   1  ",
    "   1   1  "
  ],
  sprinter: [
    "  d   d   ",
    " d www d  ",
    "drwwwwwd  ",
    " dddrddd  ",
    "  ddddd   ",
    "   ddd    ",
    "    d     ",
    "          ",
    "          ",
    "          "
  ],
  armored: [
    "  111111  ",
    " 11r11r11 ",
    " 11111111 ",
    " 11111111 ",
    " 11111111 ",
    " 33333333 ",
    " 33333333 ",
    "  33  33  ",
    "  33  33  ",
    "  33  33  "
  ],
  manager: [
    "   wwwww  ",
    "  wrwwrw  ",
    "  wwwwww  ",
    "  wwwwww  ",
    " wwwwwwww ",
    " ww11ww11 ",
    " ww11ww11 ",
    "   2  2   ",
    "  22  22  ",
    "  22  22  "
  ],
  // Loot items
  gem: [
    "    33    ",
    "   3333   ",
    "  333333  ",
    " 33333333 ",
    "  333333  ",
    "   3333   ",
    "    33    ",
    "          ",
    "          ",
    "          "
  ],
  chest: [
    "          ",
    " 33333333 ",
    " 33333333 ",
    " 3yyyyyy3 ",
    " 3yyyyyy3 ",
    " 33333333 ",
    " 33333333 ",
    "    3333  ",
    "   333333 ",
    "  3333333 "
  ],
  heart: [
    "   rr rr  ",
    "  rrrrrr  ",
    " rrrrrrrr ",
    " rrrrrrrr ",
    "  rrrrrr  ",
    "   rrrr   ",
    "    rr    ",
    "    rr    ",
    "          ",
    "          "
  ]
};
